module.exports = __webpack_public_path__ + "img/level_six_hover.a8df0c84.png";